import apiFetch from '../apiFetch'

export default function (body, processingAgencyId, token) {
  return apiFetch({ endPoint: 'ProcessingAgency/' + processingAgencyId, method: 'PUT', body: body, token: token })
}
